import correlation from '../../assets/images/icons/correlation.svg';
import Button from '../../components/Button';
import { ButtonContainer } from '../../components/Form';
import Loader from '../../components/Loader';
import { Container } from './styles';

import NoData from '../../components/NoData';
import Transitions from '../../components/Transition';
import ItensList from './components/ItensList';
import Title from './components/Title';
import useItensRelations from './useItensRelations';

export default function ItensRelations() {
  const {
    isLoading,
    getErrorMessageByFieldName,
    itens,
    handleCorrespondingCodeChange,
    handleCorrespondingCodeConfirmChange,
    isFormValid,
    handleItensRelationsSubmit,
    hasError,
    handleTryAgain,
  } = useItensRelations();

  const hasPendingItens = itens?.length > 0;

  return (
    <Transitions>
      <Loader isLoading={isLoading} />
      <Container>
        {!hasError && (
          <>
            <div className="asideGif">
              <img src={correlation} alt="busGif"/>
            </div>

            <div className="asideLogin">
              <Title />
              <div className="loginForm">
                {hasPendingItens && (
                  <ItensList
                    getErrorMessageByFieldName={getErrorMessageByFieldName}
                    itens={itens}
                    handleCorrespondingCodeChange={handleCorrespondingCodeChange}
                    handleCorrespondingCodeConfirmChange={handleCorrespondingCodeConfirmChange}
                  />
                )}

                {!hasPendingItens && (
                  <NoData
                    icon='emptyBox'
                    label={<>Todos os itens deste resultado já foram relacionados! 😃</>}
                  />
                )}
              </div>

              {hasPendingItens && (
                <ButtonContainer flexDirection='column'>
                  <Button type="button" onClick={handleItensRelationsSubmit} disabled={!isFormValid}>
                  Relacionar itens
                  </Button>
                </ButtonContainer>
              )}
            </div>
          </>
        )}

        {hasError && (
          <NoData
            icon='sad'
            label={<>
              Não foi possível buscar os itens sem relacionamento.
              <button type="button" onClick={() => handleTryAgain()}>Tentar Novamente</button>
            </>}
          />
        )}
      </Container>
    </Transitions>
  );
}
